import React from "react";
import {AlertConfiguration} from "../../util/Util";

const ThinClientConfiguration = () => {
    return (
        <AlertConfiguration></AlertConfiguration>
    );
}

export default ThinClientConfiguration



// WEBPACK FOOTER //
// ./src/components/devicemanagement/thinclient/ThinClientConfiguration.js